var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStargray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0572 0.547919C14.4324 -0.163227 15.4509 -0.163225 15.8261 0.547921L19.7921 8.06503C19.9368 8.33928 20.2006 8.53089 20.5061 8.58375L28.8809 10.0328C29.6732 10.1699 29.9879 11.1385 29.4275 11.7151L23.5039 17.81C23.2878 18.0324 23.187 18.3424 23.2312 18.6493L24.441 27.062C24.5554 27.8578 23.7315 28.4565 23.0099 28.1017L15.3829 24.3514C15.1046 24.2146 14.7786 24.2146 14.5004 24.3514L6.87329 28.1017C6.15174 28.4565 5.32777 27.8578 5.44223 27.062L6.65205 18.6493C6.69619 18.3424 6.59545 18.0324 6.37934 17.81L0.455728 11.7151C-0.104668 11.1385 0.210063 10.1699 1.00235 10.0328L9.37713 8.58375C9.68267 8.53089 9.94639 8.33928 10.0911 8.06503L14.0572 0.547919Z",
    fill: "#EAEAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStargray);
export default __webpack_public_path__ + "static/media/rating_stargray.0506c710bb418d214472095e1fc39699.svg";
export { ForwardRef as ReactComponent };